export const styles = {
    exclamationIcon: "w-full mb-8",
    title: "font-normal text-gray-800 break-all",
    titleSpan: "font-semibold text-blue-600",
    dataListItem: "font-semibold text-blue-600 text-[16px] text-start px-8",
    btnContainer: "flex gap-4 mt-10 justify-center",
  };
  